import { Amazon, Blockquote, Youtube, Twitter } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Amazon,
  Blockquote,
  Youtube,
  Twitter,
  React
};